namespace TabAurous.ECommerce {
    export namespace ECommSalesReportService {
        export const baseUrl = 'ECommerce/ECommSalesReport';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/ECommSalesReport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ECommSalesReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
